import { useUser } from '../../hooks/useUser';
import { useMessages } from '../../hooks/useMessages';
import { OpenChats } from './MessageViews/OpenChatsDisplay';
import { UploadMessage } from './MessageForms/UploadMessage';
import { EditDirectMessage } from './MessageForms/EditMessage';
import { ActiveMessages } from './MessageViews/ActiveMessagesDisplay';
import '../../css/Messages.css';

export const Messages: React.FC = () => {
  const { user, isUserProfile } = useUser();
  const { editingMessage } = useMessages();

  return (
    <div>
      {user && isUserProfile(user) ? (
        <div className="messages-container">
          <OpenChats />
          <ActiveMessages />
          {editingMessage ? <EditDirectMessage /> : <UploadMessage />}
        </div>
      ) : (
        <div id="sign-in-prompt-no-user">Sign in or create an account to use Messaging feature</div>
      )}
    </div>
  );
};
